module.exports = __webpack_public_path__ + "img/ywt_list_img4.8f000b4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/saasIntroduction/ywt_list_img4.png
// module id = k8MU
// module chunks = 136